// This file is automatically generated. Do not edit manually.

import { ServerSideDataModelRequest } from "src/api/generated/common/dataGrids/serverSideDataModelRequest";
import { ProductChangeView } from "src/api/generated/erp/db/types/tables/productChangeView";
import { AppUser } from "src/api/generated/postgres/db/types/role_management/tables/appUser";
import { ProductChangeCategory } from "src/api/generated/erp/db/types/tables/productChangeCategory";
import { ProductChangePackage } from "src/api/generated/erp/db/types/tables/productChangePackage";
import { ServerSideDataModelResult } from "src/api/generated/common/dataGrids/serverSideDataModelResult";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ProductChangeQueryApi {
	export async function getHandlingGridData(args: {
		packageId: number | null | undefined;
		categoryId: number | null | undefined;
		responsiblePersonId: number | null | undefined;
		showCancelled: boolean;
		searchQuery: string;
		dataModelRequest: ServerSideDataModelRequest;
	}): Promise<ProductChangeQueryApi_GridData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/changes/query/getHandlingGridData",
			method: "POST",
			data: {
				packageId: args.packageId,
				categoryId: args.categoryId,
				responsiblePersonId: args.responsiblePersonId,
				showCancelled: args.showCancelled,
				searchQuery: args.searchQuery,
				dataModelRequest: args.dataModelRequest,
			},
		});
		return response as ProductChangeQueryApi_GridData;
	}

	export async function getMyInImplementationChanges(): Promise<Array<ProductChangeView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/changes/query/getMyInImplementationChanges",
			method: "POST",
			data: {},
		});
		return response as Array<ProductChangeView>;
	}

	export async function getResponsiblePersonOptions(args: {
		currentSelection: number | null | undefined;
		searchQuery: string;
	}): Promise<Array<AppUser>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/productChanges/changes/query/getResponsiblePersonOptions",
			method: "POST",
			data: {
				currentSelection: args.currentSelection,
				searchQuery: args.searchQuery,
			},
		});
		return response as Array<AppUser>;
	}
}

export interface ProductChangeQueryApi_GridData {
	categoryOptions: Array<ProductChangeCategory>;
	packageOptions: Array<ProductChangePackage>;
	productChanges: ServerSideDataModelResult<ProductChangeView>;
}
